var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about",class:_vm.view},[(_vm.$q.platform.is.desktop)?_c('h5',{staticClass:"text-grey-1 text-bold"},[_vm._v("Over")]):_vm._e(),_c('about',{attrs:{"with-cols":false,"tenant-name":_vm.tenantName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }